import React from "react";
import "./GovBody.css";
import { useTranslation } from "react-i18next";

/* Image Imports */
import member1 from "../../Asset/Images/Operator_President_dhanraj.jpeg";
import member2 from "../../Asset/Images/Center Head_Roshani.jpeg";
import member4 from "../../Asset/Images/caretaker_tejas.jpeg";
import member5 from "../../Asset/Images/Mr_Deepak.jpeg";
import member6 from "../../Asset/Images/Dr_Shruti.jpeg";
import member7 from "../../Asset/Images/Mr_Dinesh.jpeg";
import membernew from "../../Asset/Images/Mr_Atul_Kamble.jpeg";
import member8 from "../../Asset/Images/Ms_Nikita.png";
import member9 from "../../Asset/Images/Ms_Shriya.jpeg";
import member10 from "../../Asset/Images/Mr_Yashodhan.png";
import member11 from "../../Asset/Images/Mr_Mahadev.jpeg";

const GovBody = () => {
  const { t } = useTranslation();

  const mainTeam = [
    { img: member1, nameKey: "gb.name_dhanraj", roleKey: "gb.role_president", link: "https://wa.me/917066883322", connect: true },
    { img: member2, nameKey: "gb.name_roshni", roleKey: "gb.role_manager", link: "https://wa.me/message/OB57KHE64DB4H1y", connect: true },
    { img: membernew, nameKey: "gb.name_atul", roleKey: "gb.role_advocate", connect: false },
    { img: member6, nameKey: "gb.name_shruti", roleKey: "gb.role_healthcare", connect: false },
    { img: member7, nameKey: "gb.name_dinesh", roleKey: "gb.role_psychotherapist", connect: false },
    { img: member4, nameKey: "gb.name_tejas", roleKey: "gb.role_caretaker", connect: false },
    { img: member5, nameKey: "gb.name_deepak", roleKey: "gb.role_ambulance", connect: false },
  ];

  const devTeam = [
    { img: member8, nameKey: "gb.name_nikita", roleKey: "gb.role_dev_lead", link: "https://wa.me/qr/MKHKC7VVV52WF1", connect: true },
    { img: member9, nameKey: "gb.name_shriya", roleKey: "gb.role_social", connect: false },
    { img: member10, nameKey: "gb.name_yashodhan", roleKey: "gb.role_social", connect: false },
    { img: member11, nameKey: "gb.name_mahadev", roleKey: "gb.role_social", connect: false }
  ];

  const renderGrid = (items) => (
    <div className="gb_grid">
      {items.map((member, index) => (
        <div className="gb_card" key={index}>
          <img src={member.img} alt={t(member.nameKey)} />
          <div className="gb_overlay">
            <h3>{t(member.nameKey)}</h3>
            <p>{t(member.roleKey)}</p>
            {member.connect && (
              <a href={member.link} target="_blank" rel="noopener noreferrer" className="gb_link">
                {t('common.connect')}
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="gb_page_wrapper">
      <section className="gb_modern">
        <h2>{t('gb.main_title')}</h2>
        {renderGrid(mainTeam)}
      </section>

      <section className="gb_modern dev_section">
        <h2>{t('gb.dev_title')}</h2>
        {renderGrid(devTeam)}
      </section>
    </div>
  );
};

export default GovBody;